// extracted by mini-css-extract-plugin
export default {"theme-container":"SocialList_theme-container__8N0pI","link":"SocialList_link__iwCNg","item":"SocialList_item__u+hmG","icon":"SocialList_icon__qRPJ-"};